import React from 'react'
import { Box } from '@mui/material'

const IwAudioLoader = (props) => {
    const { color } = props;

    return (
        <Box
            sx={{
                width: "3px",
                height: "12px",
                borderRadius: "4px",
                display: "block",
                margin: "8px auto",
                position: "relative",
                background: "currentColor",
                color,
                boxSizing: "border-box",
                animation: "animloader 0.3s 0.2s linear infinite alternate",
                "::after, ::before": {
                    content: '""',
                    width: "3px",
                    height: "16px",
                    borderRadius: "4px",
                    background: "currentColor",
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    left: "7px",
                    boxSizing: "border-box",
                    animation: "animloader 0.3s 0.55s linear infinite alternate",
                },
                "::before": {
                    left: "-7px",
                    animationDelay: "0s",
                    animationDuration: "0.4s",
                },

                "@keyframes animloader": {
                    "0%": { height: "16px" },
                    "100%": { height: "4px" },
                },
            }}
            component="span"
        />
    );
}

export default IwAudioLoader